// extracted by mini-css-extract-plugin
export default {"logotype":"zIOgD","logotypeImg":"M_ALl","logoKaz":"Zs00s"};